module.exports = __webpack_public_path__ + "static/img/cart.ef543860.svg";